import BaseLink, { type BaseLinkProps } from '../BaseLink';

type Props = BaseLinkProps;

export default function Link({ href, color = 'secondary', ...props }: Props) {
  return (
    <BaseLink
      href={href}
      color={color}
      {...props}
    />
  );
}
